var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Scroll",
    { ref: "scroller", staticClass: "task-log--wrapper" },
    [
      _vm._l(_vm.taskLogs, function (taskLogPage, pageIndex) {
        return _c(
          "div",
          { staticClass: "task-log--page" },
          _vm._l(taskLogPage, function (taskLog) {
            return _c("div", { staticClass: "task-log" }, [
              _c("span", { staticClass: "task-log__date" }, [
                _vm._v(_vm._s(_vm.toDate(taskLog.date))),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "task-log__name" }, [
                _vm._v(_vm._s(taskLog.name)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "task-log__text" }, [
                _vm._v(_vm._s(taskLog.text)),
              ]),
            ])
          }),
          0
        )
      }),
      _vm._v(" "),
      _vm.loading ? _c("div", [_vm._v("Загрузка..")]) : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }